import React from 'react';

// Renders a set of values (phone numbers, emails) on one slash-separated
// line instead of repeating an icon/label per entry. Each entry sits in its
// own no-wrap box so a single number or address is never split mid-string
// across a line break — only whole entries wrap, and the slash always stays
// attached to the entry that follows it. Plain-text entries (no
// hrefPrefix — e.g. a street address) are allowed to wrap, since a long
// address forced onto one line overflows narrow screens.
export default function SlashList({ values, hrefPrefix, className = '', linkClassName = '' }) {
  return (
    <span className={`inline-flex flex-wrap items-baseline gap-x-1.5 gap-y-1 ${className}`}>
      {values.map((v, i) => (
        <span key={i} className={`inline-flex items-baseline ${hrefPrefix ? 'whitespace-nowrap' : 'min-w-0'}`}>
          {i > 0 && <span className="text-gray-400 mr-1.5" aria-hidden="true">/</span>}
          {hrefPrefix ? (
            <a href={`${hrefPrefix}${v}`} className={linkClassName}>{v}</a>
          ) : v}
        </span>
      ))}
    </span>
  );
}
